<script>
export default {
  install(Vue) {
    Vue.$mediaWidth = function() {
      try {
        return window.mediaWidth();
      } catch (err) {
        console.log(err);
        return "";
      }
    };
  }
}
</script>
